import axiosClient from '../../../services/axiosClient';
import swal from "sweetalert";
import {
    loginConfirmedAction,
    Logout,
} from '../store/actions/AuthActions';

export function signUp(email, password) {
    // Placeholder: if your backend has a signup endpoint, wire it here.
    // Keeping Firebase signup disabled by default.
    return Promise.reject(new Error('Signup not implemented for backend'));
}

export function login(email, password) {
    // Call backend auth endpoint
    const postData = { email, password };
    // Debug logs
    // eslint-disable-next-line no-console
    console.log('[AuthService] POST /auth/login', { email });
    return axiosClient.post('/auth/login', postData).then((res) => {
        // eslint-disable-next-line no-console
        console.log('[AuthService] login success', res.status);
        return res;
    }).catch((err) => {
        // eslint-disable-next-line no-console
        console.log('[AuthService] login error', err?.response?.status, err?.message);
        throw err;
    });
}

export function formatError(errorResponse) {
    try {
        // Try to read common backend error shapes first
        const message =
            (errorResponse && (errorResponse.message || errorResponse.error || errorResponse.detail)) ||
            (errorResponse && errorResponse.errors && JSON.stringify(errorResponse.errors)) ||
            'Authentication failed';
        swal("Oops", message, "error", { button: "Try Again!", });
        return message;
    } catch (e) {
        swal("Oops", "Authentication failed", "error", { button: "Try Again!", });
        return 'Authentication failed';
    }
}

export function saveTokenInLocalStorage(tokenDetails) {
    // Compute expiration with a safe default (24h) if expiresIn is missing
    const defaultTtlMs = 24 * 60 * 60 * 1000; // 24 hours
    const ttlMs = tokenDetails && Number(tokenDetails.expiresIn)
        ? Number(tokenDetails.expiresIn) * 1000
        : defaultTtlMs;
    tokenDetails.expireDate = new Date(new Date().getTime() + ttlMs);

    // Persist in localStorage
    localStorage.setItem('userDetails', JSON.stringify(tokenDetails));
    // Note: Les headers sont gérés automatiquement par axiosClient
}

export function runLogoutTimer(dispatch, timer, navigate) {
    setTimeout(() => {
        //dispatch(Logout(history));
        dispatch(Logout(navigate));
    }, timer);
}

export function checkAutoLogin(dispatch, navigate) {
    const tokenDetailsString = localStorage.getItem('userDetails');
    let tokenDetails = '';
    if (!tokenDetailsString) {
        // Ne pas rediriger si on est déjà sur une page d'auth
        const currentPath = window.location.pathname;
        if (!currentPath.includes('/login') && !currentPath.includes('/page-register') && !currentPath.includes('/page-forgot-password')) {
            dispatch(Logout(navigate));
        }
		return;
    }

    tokenDetails = JSON.parse(tokenDetailsString);
    let expireDate = new Date(tokenDetails.expireDate);
    let todaysDate = new Date();

    if (todaysDate > expireDate) {
        // Nettoyer le localStorage des données expirées
        console.log('Token expiré - Nettoyage du localStorage dans checkAutoLogin');
        localStorage.removeItem('userDetails');
        localStorage.removeItem('auth_token');
        localStorage.removeItem('persist:root');
        localStorage.removeItem('persist:auth');
        
        // Ne pas rediriger si on est déjà sur une page d'auth
        const currentPath = window.location.pathname;
        if (!currentPath.includes('/login') && !currentPath.includes('/page-register') && !currentPath.includes('/page-forgot-password')) {
            dispatch(Logout(navigate));
        }
        return;
    }
    
    // Token valide - si on est sur une page d'authentification, rediriger vers le dashboard
    const currentPath = window.location.pathname;
    if (currentPath.includes('/login') || currentPath.includes('/page-register') || currentPath.includes('/page-forgot-password')) {
        console.log('Token valide et sur page d\'auth - Redirection vers dashboard');
        dispatch(loginConfirmedAction(tokenDetails));
        
        // Rediriger selon le type d'utilisateur
        const user = tokenDetails.user || {};
        const extra = tokenDetails.extra || {};
        
        let dashboardRoute = '/admin/dashboard'; // Par défaut admin
        
        if (extra && extra.isAdmin === true) {
            // Admin
            console.log('Redirection vers dashboard admin');
            dashboardRoute = '/admin/dashboard';
        } else if (user && user.user_type_id === 2) {
            // Consultant
            console.log('Redirection vers dashboard consultant');
            dashboardRoute = '/consultant/dashboard';
        } else if (user && user.user_type_id === 1 && (!extra || extra.isAdmin === false)) {
            // Entreprise
            console.log('Redirection vers dashboard entreprise');
            dashboardRoute = '/entreprise/dashboard';
        }
        
        navigate(dashboardRoute);
        return;
    }
		
    dispatch(loginConfirmedAction(tokenDetails));
	
    const timer = expireDate.getTime() - todaysDate.getTime();
    runLogoutTimer(dispatch, timer, navigate);
}
